export var OrderType;
(function (OrderType) {
    /**
     * The customer will pick up the order themselves and return it as well.
     */
    OrderType["PickUp"] = "PickUp";
    /**
     * The order will be delivered and picked up again by Goodless.
     */
    OrderType["Delivery"] = "Delivery";
})(OrderType || (OrderType = {}));
//# sourceMappingURL=OrderType.js.map